import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import * as actionCreators from "../actions/actionCreators.js";


import RAsheets from "../components/RAsheets";


function mapStateToProps(state){
	//console.log("Connecting state", state.series);
	return {
		lang: state.data.lang,
		auth: state.data.auth,
	}
}

function mapDispatchToProps(dispatch){
	return bindActionCreators(actionCreators, dispatch);
}


const RAsheetsContainer = connect(mapStateToProps, mapDispatchToProps)(RAsheets);

export default RAsheetsContainer;


// WEBPACK FOOTER //
// ./src/containers/RAsheetsContainer.js